'use client'
import { memo, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { motion, useInView, Variants } from 'motion/react'
import { mq, vw, designGrid, getP40, getP20, getMargin20, defaultGrid, getP40Contents } from '@/styles'
import { VideoLocal } from '../VideoLocal'

export const HeaderTeamUp = memo(() => {
  const ref = useRef(null)
  const [videoReady, setVideoReady] = useState(false)
  const isInView = useInView(ref, { once: false })

  console.log('header teaam up')
  useEffect(() => {
    setTimeout(() => {
      setVideoReady(true)
    }, 1000)
  }, [])

  useEffect(() => {
    if (!videoReady) return
    document.body.classList[isInView ? 'remove' : 'add']('dark-mode')

    return () => {
      document.body.classList.remove('dark-mode')
    }
  }, [videoReady, isInView])

  return (
    <Header initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: .5, delay: .2 }} exit={{ opacity: 0 }}>
      <div ref={ref} className={`image-wrapper ${videoReady ? 'active' : ''}`}>
        <VideoLocal className='react-player' options={{ autoPlay: true, muted: true, loop: true }} data={{ src: '/videos/header_teamup.mp4', contentType: 'video/mp4', alt: 'Team Up intro video' }} setVideoReady={setVideoReady} play={videoReady} />
      </div>
      <motion.h1 variants={titleVariants} initial='initial' animate={videoReady ? 'animate' : 'initial'} exit='exit'>💌 An invitation to redefine<br /> the web with Digital You</motion.h1>
    </Header>
  )
})


const Header = styled(motion.header)`
  ${designGrid({})}
  margin-top: ${vw(60, 'mobile')};

  ${mq.greaterThan('tablet')} {
    align-items: center;
    margin-top: ${vw(100, 'desktop')};
  }

  h1 {
    ${getP40Contents()}
    color: var(--color-text-mode);
    font-weight: 500;
    grid-column: 1 / span 6;
    margin-bottom: 20px;
    margin-top: 8vw;
    text-align: center;
    transition: 250ms color linear;
    z-index: 5;

    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 12;
      margin-bottom: 40px;
    }
  }

  .image-wrapper {
		display: block;
    grid-column: 1 / span 6;
    height: ${vw(300, 'mobile')};
    mix-blend-mode: multiply;
    opacity: 0;
    overflow: hidden;
    padding-top: 8vw;
    margin-bottom: 8vw;
    position: relative;
    transform: translateZ(0) translate3d(0,0,0);
    transition: 300ms opacity ease;

    ${mq.greaterThan('tablet')} {
		  grid-column: 3 / span 7;
      height: ${vw(500, 'desktop')};
      margin-bottom: 0;
      transform: translateX(${vw(defaultGrid.tablet.columns.width/2 + defaultGrid.tablet.gutter.width/2, 'tablet')});
    }

    ${mq.greaterThan('desktop')} {
      transform: translateX(${vw(defaultGrid.desktop.columns.width/2 + defaultGrid.desktop.gutter.width/2, 'desktop')});
    }

    video {
      height: 100%;
      object-fit: contain;
      width: 100%;
    }

    &.active {
      opacity: 1;
    }

    .mask {
      height: 50px;
      background-color: white;
      bottom: ${vw(65, 'mobile')};
      left: 0;
      right: 0;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      user-select: none;
      width: 100%;

      ${mq.greaterThan('tablet')} {
        bottom: 0;
      }
    }

    figure {
      width: ${vw(414, 'mobile')};
      height: ${vw(334, 'mobile')};
      margin: 0 0 ${vw(60, 'mobile')} -${vw(20, 'mobile')};

      ${mq.greaterThan('tablet')} {
        width: ${vw(669, 'desktop')};
        height: ${vw(540, 'desktop')};
        margin: ${vw(35, 'desktop')} ${vw(57, 'desktop')} ${vw(75, 'desktop')};
      }

      img {
        width: 100%;
      }

      &.figure--video {
        pointer-events: none;
        user-select: none;

        > div {
          height: ${vw(334, 'mobile')} !important;
          transform: scale(1.4);
          width: ${vw(414, 'mobile')} !important;

          ${mq.greaterThan('tablet')} {
            height: ${vw(540, 'desktop')} !important;
            transform: scale(1.5);
            width: ${vw(669, 'desktop')} !important;
          }

          iframe {
            pointer-events: none;
            user-select: none;

            /* ${mq.greaterThan('tablet')} {
              width: 65.5vw !important;
            } */
          }

        }
      }
    }
  }

	.text-wrapper {
		grid-column: 1 / span 6;

		${mq.greaterThan('tablet')} {
			grid-column: 8 / span 4;
		}

    h1, p { text-align: left; }

    h1 {
      ${getP40()}

      &:last-of-type {
        ${getMargin20()}
      }
    }

    p {
      ${getP20()}
    }
	}

  button {
    z-index:1000;
    margin:${vw(30, 'mobile')} 0;

    ${mq.greaterThan('tablet')} {
      margin:${vw(10, 'mobile')} 0;
		}
  }
`

// const variants:Variants = {
//   initial: {
//     y: '-100%',
//     opacity: 0,
//     transition: {
//       ...getTransition(),
//     }
//   },
//   animate: {
//     y: 0,
//     opacity: 1,
//     transition: {
//       ...getTransition(),
//       ease: [0.6, 0.2, 0.4, 1.5],
//       delay: 2.3
//     }
//   }
// } as const

// const variantsText = {
//   initial: {
//     opacity: 0,
//     transition: {
//       ...getTransition(),
//       ease: [0.6,0.2,0.4,1.5],
//     }
//   },
//   animate: {
//     opacity: 1,
//     transition: {
//       ...getTransition(),
//       ease: [0.6,0.2,0.4,1.5],
//     }
//   }
// }


const titleVariants:Variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: {
    duration: 1,
    delay: .4
  }},
  exit: { opacity: 0, y: 20 },
}
